// CommonJS, zoals variant.js: gatsby-node.js leest hem met require, de componenten met import.
// Vult {naam} in een tekstpatroon. Een ontbrekende waarde is een fout, geen stille lege plek.
function formatText(template, values) {
    return template.replace(/\{(\w+)\}/g, (_, name) => {
        if (!values || !(name in values)) throw new Error(`Waarde {${name}} ontbreekt voor "${template}"`)
        return String(values[name])
    })
}

module.exports = { formatText }
